/**
 * Event subtitle
 * 
 * @module event-subtitle
 * @version 1.0.0
 * @extends HTMLElement
 */
class eventSubtitle extends HTMLElement {

    /**
     * Event subtitle web component
     * 
     * @constructor
     */
    constructor() {

        super();

        const intersectionObserver = this.dataset.IntersectionObserver;

        if(intersectionObserver == 'true') {
            
            const handleIntersection = (entries, observer) => {

                if (!entries[0].isIntersecting) return;
    
                // init the component
                this.initSubtitle();
    
                // Stop observing the component
                observer.unobserve(this);
            }
    
            // Start observing the component
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }
        else {
            // init the component
            this.initSubtitle();
        }
    }

    /**
     * Init subtitle label
     * 
     * @return {undefined}
     */
    initSubtitle() {

        const handleEventName = this.dataset.eventName;

        // Check the event name
        if(handleEventName) {

            let event = window.shopEvents[handleEventName];

            if (typeof event != 'undefined') {

                this.setSubtitle(event);
            }
        }
    }

    /**
     * Set subtitle label
     * 
     * @param {Object} event Current event data.
     * @return {undefined}
     */
    setSubtitle(event) {

        if (event.status == 'fixed') {
            return;
        }

        const comingSoonLabel = this.dataset.comingSoonDate;

        // Live status
        if (event.status == 'live') {
            // Check sub_status for special cases
            if (event.sub_status == 'ends-today') {
                this.innerHTML = "Ends Today";
                this.dataset.status = "ends";
            } else if (event.sub_status == 'last-two-days') {
                this.classList.add("now-live");
            } else {
                this.classList.add("now-live");
            }
        }

        // Extended status
        if (event.status == 'extended') {
            this.classList.add("now-live");
            this.dataset.status = "extended";
        }

        // Early Access status
        if (event.status == 'early-access') {
            this.classList.add("early-access");
            this.dataset.status = "early-access";

            if (event.market != 'Online') {
                // Physical events don't have early access distinction
            } else {
                // Menu context - show simple "Opens at 11AM EST" with green circle inline
                this.innerHTML = '<span style="display: inline-flex; align-items: center; white-space: nowrap;"><span style="width: 8px; height: 8px; background: linear-gradient(135deg, #5dc40c, #00aa9f); border-radius: 50%; margin-right: 6px; flex-shrink: 0;"></span>Opens at 11AM EST</span>';
            }
        }
        
        // Coming Soon status
        if (event.status == 'coming-soon') {
            if (event.market != 'Online') {
                // Physical events - show opening date or weekday
                if (event.sub_status == 'opens-soon') {
                    this.innerHTML = '<span>Opens ' + event.start_date_weekday + '</span>';
                } else if (comingSoonLabel == 'true') {
                    this.innerHTML = '<span>Opens ' + event.start_date_formatted + '</span>';
                }
            } else {
                // Online events - show both public and members dates
                if (event.sub_status == 'opens-soon') {
                    this.innerHTML = '<span class="event-subtitle__msg">Opens ' + event.start_date_day_after_weekday + '</span><span class="event-subtitle__msg members">Members Shop ' + event.start_date_weekday + '</span>';
                } else if (comingSoonLabel == 'true') {
                    this.innerHTML = '<span class="event-subtitle__msg">Opens ' + event.start_date_day_after_formatted + '</span><span class="event-subtitle__msg members">Members Shop ' + event.start_date_formatted + '</span>';
                }
            }
        }
    }
}

customElements.define('event-subtitle', eventSubtitle);
